import React, { useEffect } from "react";
import "./Banner.scss";

export default function Banner() {
  const carouselItems = [
    {
      desktopImage: "/assets/img/slider/desktop2.jpg",
    },
    {
      desktopImage: "/assets/img/slider/Automobile-LP.jpg",
    },
    // {
    //   desktopImage: "/assets/img/slider/Metals-and-minerals-LP.jpg",
    // },
    // {
    //   desktopImage: "/assets/img/slider/Chemicals-LP.jpg",
    // },
    // {
    //   desktopImage: "/assets/img/slider/Construction-LP.jpg",
    // },
    // {
    //   desktopImage: "/assets/img/slider/Fruits-LP.jpg",
    // },
    // {
    //   desktopImage: "/assets/img/slider/Dry-fruits-LP.jpg",
    // },
    // {
    //   desktopImage: "/assets/img/slider/Spices-LP.jpg",
    // },
    // {
    //   desktopImage: "/assets/img/slider/Rices-LP.jpg",
    // },
    // {
    //   desktopImage: "/assets/img/slider/Vegetables-LP.jpg",
    // },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="hero-section hero-section-full-height">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-12 p-0">
            <div
              id="hero-slide"
              className="carousel slide carousel-fade"
              data-bs-ride="carousel"
              data-bs-interval="3000"
              data-bs-wrap="true"
              data-bs-pause="false"
            >
              <div className="carousel-inner">
                {carouselItems.map((item, index) => (
                  <div
                    key={index}
                    className={`carousel-item ${index === 0 ? "active" : ""
                      }`}
                  >
                    <img
                      src={item.desktopImage}
                      className="carousel-image"
                      alt={`Slide ${index + 1}`}
                    />
                  </div>
                ))}
              </div>

              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#hero-slide"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
              </button>

              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#hero-slide"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}